import { useEffect, useMemo, useState } from "react";
import Close from "@mui/icons-material/Close";
import Edit from "@mui/icons-material/Edit";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  TextField,
  Typography,
  Select,
  MenuItem,
  Tooltip,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Tabs,
  Tab,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import "../../style.css";
import { ThemeProvider } from "@mui/styles";
import "../../Switcher.scss";
import { useDispatch, useSelector } from "react-redux";
import { StyledDataGrid } from "../../pages/CustomDataGrid";
import {
  createAdminDidCarrier,
  createAdminRoles,
  getAdminDidCarrier,
  getAdminRoles,
  updateAdminDidCarrier,
  updateAdminRoles,
} from "../../redux/actions/adminPortal/adminPortal_rolesAction";
import PageTitle from "../common/PageTitle";
const drawerWidth = 240;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{
      "& .MuiButton-root": {
        fontSize: {
          xs: "12px",   // mobile
          sm: "14px",   // tablet
          md: "14px",   // desktop
        },
        minWidth: "auto",
      },
      "& .MuiSvgIcon-root": {
        fontSize: {
          xs: "16px",
          sm: "18px",
        },
      },
    }}>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
    </GridToolbarContainer>
  );
}

function AdminRoles({ colorThem }) {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [opendid, setOpendid] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editDid, setEditDid] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [carrierName, setCarrierName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [didId, setDidId] = useState("");
  const [status, setStatus] = useState("true");
  const [statusDid, setStatusDid] = useState("true");
  const [description, setDescription] = useState("");
  const [response, setResponse] = useState("");
  const handleOpen = () => setOpen(true);
  const [roleTab, setRoleTab] = useState("role");

  const handleTabChange = (event, newValue) => {
    setRoleTab(newValue);
  };

  const handleClose = () => {
    setOpen(false);
    setRoleName("");
    setRoleId("");
    setDescription("");
    setStatus("true");
    setCarrierName("");
  };

  const handleOpenDIdCarrier = () => setOpendid(true);
  const handleCloseDIdCarrier = () => {
    setOpendid(false);
    setCarrierName("");
    setDescription("");
  };

  const handleEditCampaignOpen = () => setEdit(true);
  const handleEditCampaignClose = () => {
    setEdit(false);
    setRoleName("");
    setStatus("true");
    setDescription("");
    setRoleId("");
  };

  const handleEditDidCarrierOpen = (data) => {
    setEditDid(true);
    setDescription(data?.description);
    setCarrierName(data?.carrier_name);
    setStatusDid(data?.status === true ? "true" : "false");
    setDidId(data?.did_id);
  };

  const handleEditDidCarrierClose = () => {
    setEditDid(false);
    setCarrierName("");
    setStatusDid("true");
    setDescription("");
    setRoleId("");
  };

  useEffect(() => {
    dispatch(getAdminRoles());
    dispatch(getAdminDidCarrier())
  }, [dispatch, response]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "roleName":
        setRoleName(value);
        break;
      case "status":
        setStatus(value);
        break;
      case "description":
        setDescription(value);
        break;
      default:
        break;
    }
  };

  const handleChangeDidCarrier = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "carrierName":
        setCarrierName(value);
        break;
      case "status":
        statusDid(value);
        break;
      case "description":
        setDescription(value);
        break;
      default:
        break;
    }
  };

  const handleEdit = (data) => {
    handleEditCampaignOpen();
    setRoleName(data?.name);
    setRoleId(data?.role_id);
    setStatus(data?.status === true ? "true" : "false");
    setDescription(data?.description);
    setCarrierName(data?.carrier_name);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const request = {
      name: roleName,
      is_active: status,
      description: description,
    };
    dispatch(createAdminRoles(request, handleClose, setResponse));
  };

  const handleSubmitDidCarrier = (e) => {
    e.preventDefault();
    const request = {
      carrier_name: carrierName,
      description: description,
    };
    dispatch(createAdminDidCarrier(request, handleCloseDIdCarrier, setResponse));
  };

  const handleUpdate = () => {
    const request = {
      role_id: roleId,
      name: roleName,
      is_active: status,
      description: description,
    };
    dispatch(updateAdminRoles(request, handleEditCampaignClose, setResponse));
  };

  const handleUpdateDidCarrier = () => {
    const request = {
      // carrier_name: carrierName,
      id: didId,
      carrier_name: carrierName,
      is_active: statusDid,
      description: description,
    };
    dispatch(updateAdminDidCarrier(request, handleEditDidCarrierClose, setResponse));
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));

  const formatDateTimeJSX = (value) => {
    if (!value) return "-";

    const date = new Date(value);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return (
      <span style={{ whiteSpace: "nowrap" }}>
        <span style={{ color: "blue", fontSize: "12.215px" }}>
          {day}/{month}/{year}
        </span>
      </span>
    );
  };

  const columns = [
    {
      field: "view_buyer",
      headerName: "Action",
      headerClassName: "custom-header",
      headerAlign: "start",
      align: "start",
      sortable: false,
      width: isXs ? 60 : 70,
      minWidth: 60,
      maxWidth: 70,
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Action
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            <Tooltip title="Edit">
              <IconButton onClick={() => handleEdit(params.row)}>
                <Edit
                  index={params.row.id}
                  style={{
                    cursor: "pointer",
                    color: "#42765f",
                    fontSize: isMobile ? "12px" : "18px",
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: "custom-header",
      headerAlign: "start",
      align: "start",
      width: isXs ? 100 : 110,
      minWidth: 100,
      maxWidth: 110,
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Name
        </Typography>
      ),
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)" }} // Match header size or set your own
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      headerClassName: "custom-header",
      headerAlign: "start",
      align: "start",
      flex: 1,
      width: isXs ? 120 : 140,
      minWidth: 120,
      maxWidth: 160,
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Description
        </Typography>
      ),
      renderCell: (params) => (
        <span
          style={{
            textTransform: "capitalize",
            fontSize: "calc(0.6rem + 0.2vw)",
          }}
        >
          {params.row.description}
        </span>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Status
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            {params.row.status === true ? (
              <>
                <div
                  style={{
                    color: "white",
                    background: "green",
                    padding: isMobile ? "5px" : "7px",
                    borderRadius: "5px",
                    fontSize: "calc(0.6rem + 0.2vw)",
                    textTransform: "capitalize",
                    textAlign: "center",
                  }}
                >
                  active
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    color: "white",
                    background: "red",
                    padding: isMobile ? "5px" : "7px",
                    borderRadius: "5px",
                    fontSize: "calc(0.6rem + 0.2vw)",
                    textTransform: "capitalize",
                  }}
                >
                  Deactive
                </div>
              </>
            )}
          </div>
        );
      },
    },
  ];

  const didcolumns = [
    {
      field: "view_buyer",
      headerName: "Action",
      headerClassName: "custom-header",
      headerAlign: "start",
      align: "start",
      sortable: false,

      width: isXs ? 80 : 80,
      minWidth: 80,
      maxWidth: 80,
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Action
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            <Tooltip title="Edit">
              <IconButton onClick={() => handleEditDidCarrierOpen(params.row)}>
                <Edit
                  index={params.row.id}
                  style={{
                    cursor: "pointer",
                    color: "#42765f",
                    fontSize: isMobile ? "12px" : "18px",
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "carrier_name",
      headerName: "Did Carrier",
      headerClassName: "custom-header",
      headerAlign: "start",
      align: "start",
      width: isXs ? 100 : 140,
      minWidth: 100,
      maxWidth: 140,
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Did Carrier
        </Typography>
      ),
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)" }} // Match header size or set your own
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "updated_date",
      headerName: "Update Date",
      headerClassName: "custom-header",
      headerAlign: "start",
      align: "start",
      width: isXs ? 80 : 90,
      minWidth: 80,
      maxWidth: 90,
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Update Date
        </Typography>
      ),
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)" }} // Match header size or set your own
        >
          {formatDateTimeJSX(params.row.updated_date)}
        </Typography>
      ),
    },
    {
      field: "status",
      headerName: "Status",

      flex: 1,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Status
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            {params.row.status === true ? (
              <>
                <div
                  style={{
                    color: "white",
                    background: "green",
                    padding: isMobile ? "5px" : "7px",
                    borderRadius: "5px",
                    fontSize: "calc(0.6rem + 0.2vw)",
                    textTransform: "capitalize",
                    textAlign: "center",
                  }}
                >
                  active
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    color: "white",
                    background: "red",
                    padding: isMobile ? "5px" : "7px",
                    borderRadius: "5px",
                    fontSize: "calc(0.6rem + 0.2vw)",
                    textTransform: "capitalize",
                  }}
                >
                  Deactive
                </div>
              </>
            )}
          </div>
        );
      },
    },
  ];

  const mockDataTeam = useMemo(() => {
    const calculatedRows = [];
    state?.getAdminRoles?.roles &&
      state?.getAdminRoles?.roles.forEach((item, index) => {
        calculatedRows.push({
          id: index + 1,
          name: item?.name,
          description: item?.description,
          status: item?.is_active,
          role_id: item?.id,
        });
      });
    return calculatedRows;
  }, [state?.getAdminRoles?.roles]);

  const mockDataTeam1 = useMemo(() => {
    const calculatedRows = [];
    state?.getAdminDidCarrier?.did_carrier &&
      state?.getAdminDidCarrier?.did_carrier.forEach((item, index) => {
        calculatedRows.push({
          id: index + 1,
          carrier_name: item?.carrier_name,
          description: item?.description,
          status: item?.is_active,
          did_id: item?.id,
          added_date: item?.added_date,
          updated_date: item?.updated_date
        });
      });
    return calculatedRows;
  }, [state?.getAdminDidCarrier?.did_carrier]);

  return (
    <>
      <div className={`App ${colorThem} `}>
        <div className="contant_box">
          <Box
            className="right_sidebox mobile_top_pddng"
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >

            {/* ========== */}
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <Box
                        className="cntnt_title"
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "row", md: "row" },
                          flexWrap: "wrap",
                          justifyContent: { xs: "left", md: "space-between" },
                          alignItems: { xs: "center", md: "center" },
                          textAlign: { xs: "left", md: "left" },
                          mb: { xs: 2, md: 2, },
                          gap: { xs: 2, md: 0 },
                          width: "100%",
                        }}
                       >
                        {/* Title */}
                        <PageTitle title="Roles / DID Carrier" />

                        {/* Buttons */}
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",



                            justifyContent: { xs: "flex-end", md: "flex-end" },
                            width: { xs: "100%", md: "auto" },
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={handleOpen}
                            className="all_button_clr"
                            sx={{
                              fontSize: "14px",
                              borderRadius: "5px",
                              color: "#fff",
                              backgroundColor: "#0a140e",
                              px: 2,
                              height: "35px",
                              "&:hover": {
                                backgroundColor: "#1b3027",
                              },
                            }}
                          >
                            Add Role
                            <AddOutlinedIcon sx={{ ml: 1 }} fontSize="small" />
                          </IconButton>

                          <IconButton
                            size="small"
                            onClick={handleOpenDIdCarrier}
                            className="all_button_clr"
                            sx={{
                              fontSize: "14px",
                              borderRadius: "5px",
                              color: "#fff",
                              backgroundColor: "#f5751D!important",
                              px: 2,
                              height: "35px",
                              "&:hover": {
                                backgroundColor: "#d86410",
                              },
                            }}
                          >
                            Add Carrier
                            <AddOutlinedIcon sx={{ ml: 1 }} fontSize="small" />
                          </IconButton>
                        </Box>
                      </Box>

                      {/* -----   Add Role Modal Start   ----- */}

                      <Dialog
                        open={open}
                        className="custom_dailog_box_user"
                        onClose={handleClose}
                        sx={{ textAlign: "center" }}
                       >
                        <Box
                          sx={{
                            display: "flex",
                            paddingTop: "10px",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            className="modal_heading"
                            sx={{
                              color: "#133325",
                              fontWeight: "600",
                              width: "500px",
                            }}
                          >
                            Add Role
                          </Typography>
                          <IconButton
                            className="close_icon"
                            onClick={handleClose}
                            sx={{ float: "inline-end" }}
                          >
                            <Close />
                          </IconButton>
                        </Box>
                        <DialogContent>
                          <form>
                            <form
                              style={{
                                textAlign: "center",
                                // height: "348px",

                                // overflow: "auto",
                                paddingTop: "10px",

                                width: "auto",
                              }}
                            >
                              <TextField
                                style={{ width: "100%", margin: "7px 0" }}
                                type="text"
                                label="Name"
                                variant="outlined"
                                value={roleName}
                                onChange={(e) => {
                                  setRoleName(e.target.value);
                                }}
                              />

                              <br />
                              <FormControl
                                fullWidth
                                style={{
                                  width: "100%",
                                  margin: "7px 0",
                                }}
                              >
                                <InputLabel id="demo-simple-select-label">
                                  Status
                                </InputLabel>

                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  label="Status"
                                  helperText="Select the language."
                                  style={{ textAlign: "left" }}
                                  value={status}
                                  onChange={(e) => {
                                    setStatus(e.target.value);
                                  }}
                                >
                                  <MenuItem value={"true"}>Active</MenuItem>
                                  <MenuItem value={"false"}>
                                    Deactive
                                  </MenuItem>
                                </Select>
                              </FormControl>
                              <br />
                              <TextField
                                style={{ width: "100%", margin: "7px 0" }}
                                type="text"
                                label="Description"
                                variant="outlined"
                                value={description}
                                onChange={(e) =>
                                  setDescription(e.target.value)
                                }
                              />
                            </form>
                          </form>
                        </DialogContent>
                        <DialogActions
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            paddingBottom: "20px",
                          }}
                        >
                          <Button
                            variant="contained"
                            className="all_cancel_btn"
                            color="primary"
                            sx={{
                              fontSize: "16px !impotant",
                              background:
                                "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                              marginTop: "0px",
                              padding: "10px 20px !important",
                              textTransform: "capitalize !important",
                            }}
                            onClick={handleClose}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            className="all_button_clr"
                            color="primary"
                            sx={{
                              fontSize: "16px !impotant",
                              background: "#092b5f",
                              marginTop: "0px",
                              padding: "10px 20px !important",
                              textTransform: "capitalize !important",
                            }}
                            onClick={handleSubmit}
                          >
                            save
                          </Button>
                        </DialogActions>
                      </Dialog>

                      {/* -----   Add Role Modal End   ----- */}



                      {/* add did carrier start */}
                      <Dialog
                        open={opendid}
                        className="custom_dailog_box_user"
                        onClose={handleCloseDIdCarrier}
                        sx={{ textAlign: "center" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            paddingTop: "10px",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            className="modal_heading"
                            sx={{
                              color: "#133325",
                              fontWeight: "600",
                              width: "500px",
                            }}
                          >
                            Add Did Carrier
                          </Typography>
                          <IconButton
                            className="close_icon"
                            onClick={handleCloseDIdCarrier}
                            sx={{ float: "inline-end" }}
                          >
                            <Close />
                          </IconButton>
                        </Box>
                        <DialogContent>
                          <form>
                            <form
                              style={{
                                textAlign: "center",
                                // height: "348px",

                                // overflow: "auto",
                                paddingTop: "10px",

                                width: "auto",
                              }}
                            >
                              <TextField
                                style={{ width: "100%", margin: "7px 0" }}
                                type="text"
                                label="Did Carrier"
                                variant="outlined"
                                value={carrierName}
                                onChange={(e) => {
                                  setCarrierName(e.target.value);
                                }}
                              />


                              <br />
                              <TextField
                                style={{ width: "100%", margin: "7px 0" }}
                                type="text"
                                label="Description"
                                variant="outlined"
                                value={description}
                                onChange={(e) =>
                                  setDescription(e.target.value)
                                }
                              />
                            </form>
                          </form>
                        </DialogContent>
                        <DialogActions
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            paddingBottom: "20px",
                          }}
                        >
                          <Button
                            variant="contained"
                            className="all_cancel_btn"
                            color="primary"
                            sx={{
                              fontSize: "16px !impotant",
                              background:
                                "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                              marginTop: "0px",
                              padding: "10px 20px !important",
                              textTransform: "capitalize !important",
                            }}
                            onClick={handleCloseDIdCarrier}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            className="all_button_clr"
                            color="primary"
                            sx={{
                              fontSize: "16px !impotant",
                              background: "#092b5f",
                              marginTop: "0px",
                              padding: "10px 20px !important",
                              textTransform: "capitalize !important",
                            }}
                            onClick={handleSubmitDidCarrier}
                          >
                            save
                          </Button>
                        </DialogActions>
                      </Dialog>
                      {/* end did carrier end */}

                    </div>
                  </div>
                  {/* ----------------------------------------------
                     ----------------------------------------------
                     ----------------------------------------------
                     ---------------------------------------------- */}

                  {/* -----   Edit Role Modal Start   ----- */}
                  <Dialog
                    className="custom_dailog_box_user"
                    open={edit}
                    onClose={handleEditCampaignClose}
                    sx={{ textAlign: "center" }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        paddingTop: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        className="modal_heading"
                        sx={{
                          color: "#133325",
                          fontWeight: "600",
                          width: "500px",
                        }}
                      >
                        Update Role
                      </Typography>
                      <IconButton
                        className="close_icon"
                        onClick={handleEditCampaignClose}
                        sx={{ float: "inline-end" }}
                      >
                        <Close />
                      </IconButton>
                    </Box>
                    <DialogContent>
                      <form>
                        <form
                          style={{
                            textAlign: "center",
                            // height: "348px",
                            // overflow: "auto",
                            paddingTop: "10px",
                            width: "auto",
                          }}
                        >
                          <TextField
                            style={{ width: "100%", margin: " 5px 0 5px 0" }}
                            type="text"
                            label="Name"
                            variant="outlined"
                            name="roleName"
                            value={roleName}
                            onChange={handleChange}
                          />
                          <br />
                          <FormControl
                            fullWidth
                            style={{
                              width: "100%",
                              margin: "7px 0",
                            }}
                          >
                            <InputLabel id="demo-simple-select-label">
                              Status
                            </InputLabel>

                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Status"
                              helperText="Select the language."
                              style={{ textAlign: "left" }}
                              value={status}
                              onChange={(e) => {
                                setStatus(e.target.value);
                              }}
                            >
                              <MenuItem value={"true"}>Active</MenuItem>
                              <MenuItem value={"false"}>Deactive</MenuItem>
                            </Select>
                          </FormControl>
                          <TextField
                            style={{ width: "100%", margin: " 5px 0 5px 0" }}
                            type="text"
                            label="Description"
                            variant="outlined"
                            name="description"
                            value={description}
                            onChange={handleChange}
                          />
                        </form>
                      </form>
                    </DialogContent>
                    <DialogActions
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        paddingBottom: "20px",
                      }}
                    >
                      <Button
                        variant="contained"
                        className="all_button_clr"
                        color="primary"
                        onClick={handleUpdate}

                        sx={{
                          fontSize: "16px !impotant",

                          marginTop: "0px",
                          padding: "10px 20px !important",
                          textTransform: "capitalize !important",
                        }}
                      >
                        Update
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {/* -----   Edit Campaign Modal End   ----- */}


                  {/* -----   Edit DID Carrier Modal Start   ----- */}
                  <Dialog
                    className="custom_dailog_box_user"
                    open={editDid}
                    onClose={handleEditDidCarrierClose}
                    sx={{ textAlign: "center" }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        paddingTop: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        className="modal_heading"
                        sx={{
                          color: "#133325",
                          fontWeight: "600",
                          width: "500px",
                        }}
                      >
                        Update DID Carrier
                      </Typography>
                      <IconButton
                        className="close_icon"
                        onClick={handleEditDidCarrierClose}
                        sx={{ float: "inline-end" }}
                      >
                        <Close />
                      </IconButton>
                    </Box>
                    <DialogContent>
                      <form>
                        <form
                          style={{
                            textAlign: "center",
                            // height: "348px",

                            // overflow: "auto",
                            paddingTop: "10px",
                            padding: "5px",
                            width: "auto",
                          }}
                        >
                          <TextField
                            style={{ width: "100%", margin: " 5px 0 5px 0" }}
                            type="text"
                            label="Did Carrier"
                            variant="outlined"
                            name="roleName"
                            value={carrierName}
                            onChange={handleChangeDidCarrier}
                          />
                          <br />
                          <FormControl
                            fullWidth
                            style={{
                              width: "100%",
                              margin: "7px 0",
                            }}
                          >
                            <InputLabel id="demo-simple-select-label">
                              Status
                            </InputLabel>

                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Status"
                              helperText="Select the language."
                              style={{ textAlign: "left" }}
                              value={statusDid}
                              onChange={(e) => {
                                setStatusDid(e.target.value);
                              }}
                            >
                              <MenuItem value={"true"}>Active</MenuItem>
                              <MenuItem value={"false"}>Deactive</MenuItem>
                            </Select>
                          </FormControl>
                          <TextField
                            style={{ width: "100%", margin: " 5px 0 5px 0" }}
                            type="text"
                            label="Description"
                            variant="outlined"
                            name="description"
                            value={description}
                            onChange={handleChange}
                          />
                        </form>
                      </form>
                    </DialogContent>
                    <DialogActions
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        paddingBottom: "20px",
                      }}
                    >
                      <Button
                        variant="contained"
                        className="all_button_clr"
                        color="primary"
                        onClick={handleUpdateDidCarrier}
                        sx={{
                          fontSize: "16px !impotant",

                          marginTop: "0px",
                          padding: "10px 20px !important",
                          textTransform: "capitalize !important",
                        }}
                      >
                        Update
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {/* -----   Edit DId carrier Modal End   ----- */}
                </div>
              </div>
            </div>

            {/* ========== */}
           <Grid container spaceing={1}>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: {
                      xs: "flex-start",
                      md: "space-between",
                    },
                    alignItems: { xs: "flex-start", md: "center" },
                    flexDirection: { xs: "column", md: "row" }, // 📱 stack on mobile
                    mb: 2,
                    gap: 2,
                  }}
                >
                  <Tabs
                    className="d-xs-block d-sm-block d-md-none d-lg-none"
                    value={roleTab}
                    onChange={handleTabChange}
                    TabIndicatorProps={{ style: { display: "none" } }}
                    sx={{

                      minHeight: "25px",
                      overflow: "hidden",
                      mb: { xs: 0, md: 2 },

                      width: { xs: "100%", md: "auto" }, // 📱 full width
                      background: "#527061",
                      borderRadius: "10px",
                      width: "auto!important",
                      border: "1px solid #e5e7eb",
                      p: "4px",

                      "& .MuiTab-root": {
                        flex: { xs: 1, md: "unset" }, // 📱 equal width tabs
                        minHeight: "30px",
                        padding: "9px 7px !important",
                        fontSize: "11px!important",
                        fontWeight: 400,
                        overflow: "hidden",
                        textTransform: "none",
                        borderRadius: "8px",
                        color: "#e5e7eb",
                        transition:
                          "background 0.25s ease, color 0.25s ease",
                      },

                      "& .MuiTab-root:hover": {
                        background: "#f97316",
                        color: "#ffffff",
                      },

                      "& .Mui-selected": {
                        background: "#f97316",
                        color: "#ffffff !important",
                      },
                    }}
                  >
                    <Tab label="Add Role" value="role" />
                    <Tab label="Add Carrier" value="carrier" />
                  </Tabs>
                </Box>
              </Grid>
            </Grid>

            <Grid container spaceing={1} >

              {/* Mobile table */}

              {/* Add role mobile table  */}

              {roleTab === "role" ? (<>
                <Grid item md={12} xs={12} sx={{ display: { xs: "block", md: "none", } }}>
                  <ThemeProvider theme={theme}>
                    <div style={{ height: "100%", width: "100%" }}>
                      <StyledDataGrid
                        rows={mockDataTeam}
                        columns={columns}
                        // columns={
                        //   roleTab === "role" ? columns : didcolumns
                        // }
                        density="compact"

                        components={{ Toolbar: GridToolbar }}
                        slots={{
                          toolbar: CustomToolbar,
                        }}
                        autoHeight
                      />
                    </div>
                  </ThemeProvider>
                </Grid></>) : (<>
                  {/* Add carrier mobile table  */}
                  <Grid item xs={12} md={12} sx={{ display: { xs: "block", md: "none" } }}>
                    <ThemeProvider theme={theme}>
                      <div style={{ height: "100%", width: "100%" }}>
                        <StyledDataGrid
                          rows={mockDataTeam1}
                          columns={didcolumns}
                          density="compact"
                          // getRowClassName={(params) =>
                          //   isRowBordered(params)
                          //     ? "borderedGreen"
                          //     : "borderedRed"
                          // }
                          components={{ Toolbar: GridToolbar }}
                          slots={{
                            toolbar: CustomToolbar,
                          }}
                          autoHeight // Automatically adjust the height to fit all rows
                        />
                      </div>
                    </ThemeProvider>
                  </Grid></>)}





            </Grid>

            {/* Desktop table */}
            <Grid container spacing={1} >
              <Grid item xs={12} md={6} sx={{ display: { xs: "none", md: "block" } }}>
                <ThemeProvider theme={theme}>
                  <div style={{ height: "100%", width: "100%" }}>
                    <StyledDataGrid
                      rows={mockDataTeam}
                      columns={columns}
                      density="compact"

                      components={{ Toolbar: GridToolbar }}
                      slots={{
                        toolbar: CustomToolbar,
                      }}
                      autoHeight // Automatically adjust the height to fit all rows
                    />
                  </div>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} md={6} sx={{ display: { xs: "none", md: "block" } }}>
                <ThemeProvider theme={theme}>
                  <div style={{ height: "100%", width: "100%" }}>
                    <StyledDataGrid
                      rows={mockDataTeam1}
                      columns={didcolumns}
                      density="compact"
                      // getRowClassName={(params) =>
                      //   isRowBordered(params)
                      //     ? "borderedGreen"
                      //     : "borderedRed"
                      // }
                      components={{ Toolbar: GridToolbar }}
                      slots={{
                        toolbar: CustomToolbar,
                      }}
                      autoHeight // Automatically adjust the height to fit all rows
                    />
                  </div>
                </ThemeProvider>
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    </>
  );
}

export default AdminRoles;
